<div>
  <script>
    parent.postMessage(location.hash, location.origin);
  </script>
</div>
